module.exports = __webpack_public_path__ + "static/media/ic_lactancia.f85b8b37.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/services/ic_lactancia.webp
// module id = 173
// module chunks = 1